export type ManualAssetType = 'stocks' | 'options' | 'futures' | 'forex' | 'crypto';

export type ManualFinancialInput = {
  assetType: ManualAssetType;
  side: 'Long' | 'Short';
  status: 'open' | 'closed';
  quantity: number;
  entryPrice?: number;
  exitPrice?: number;
  contractMultiplier?: number;
  grossPnl?: number;
  commissions?: number;
  otherFees?: number;
  netPnl?: number;
};

export function calculateManualFinancials(input: ManualFinancialInput) {
  const fees = (input.commissions || 0) + (input.otherFees || 0);
  let grossPnl = input.grossPnl;
  let grossPnlSource: 'manual' | 'calculated' | 'missing' = grossPnl == null ? 'missing' : 'manual';
  const knownMultiplier = input.assetType === 'stocks' ? 1 : input.contractMultiplier;
  if (grossPnl == null && input.status === 'closed' && input.entryPrice != null && input.exitPrice != null
    && knownMultiplier != null && Number.isFinite(knownMultiplier) && knownMultiplier > 0) {
    const direction = input.side === 'Long' ? 1 : -1;
    grossPnl = (input.exitPrice - input.entryPrice) * input.quantity * knownMultiplier * direction;
    grossPnlSource = 'calculated';
  }
  const netPnl = input.netPnl ?? (grossPnl == null ? undefined : grossPnl - fees);
  return {
    grossPnl,
    netPnl,
    fees,
    grossPnlSource,
    netPnlSource: input.netPnl == null ? (grossPnl == null ? 'missing' : 'calculated') : 'manual',
  } as const;
}

export function validateManualInstrument(input: {
  assetType: ManualAssetType;
  optionRight?: string;
  strike?: number;
  expiration?: string;
  contractMultiplier?: number;
}) {
  if (input.assetType === 'options') {
    if (!['call', 'put'].includes(String(input.optionRight || '').toLowerCase())) return 'Select Call or Put for the option.';
    if (!(Number(input.strike) > 0)) return 'Enter a valid option strike.';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(input.expiration || ''))) return 'Enter the option expiration date.';
  }
  if (['options', 'futures'].includes(input.assetType) && input.contractMultiplier != null
    && (!Number.isFinite(input.contractMultiplier) || input.contractMultiplier <= 0)) return 'Contract multiplier must be greater than zero.';
  return '';
}
